<ion-header translucent="false" class="ion-no-border">
	<ion-toolbar>
		<ion-title [translate]="titleKey ?? 'public.notFound.title'" />
	</ion-toolbar>
</ion-header>

<ion-content fullscreen="true">
	<ion-card class="ion-text-center">
		<ion-card-content>
			<h1 [translate]="titleKey ?? 'public.notFound.title'"></h1>
			<p [translate]="messageKey ?? 'public.notFound.message'"></p>

			<ion-button [routerLink]="[link ?? '/']" [replaceUrl]="true">
				<ion-icon slot="start" name="home"></ion-icon>
				{{'generic.backToHome' | translate}}
			</ion-button>
		</ion-card-content>
	</ion-card>

	<div class="footer-spacer"></div>
</ion-content>
